import DetailsListOverflowTooltip from './DetailsListOverflowTooltip';

export default DetailsListOverflowTooltip;
